import extend from '@/utils/vuex-extend';
import {dialog} from '@/vuex-extend';
import {getOrderDetail, getReturnReasonList} from '@/api/oms/order';
import {wait} from '@/utils/wait';
import {Message} from 'element-ui';

export default extend(dialog, {
	namespaced: true,
	state: {
		orderCode: 0,
		detail: {},
		form: {},
		returnReasonList: []
	},
	actions: {
		async afterOpenDialog({dispatch, commit, state}, payload) {
			const {orderCode} = state;
			await wait(dispatch, 'oms.order.detail', async function () {
				 let response = await getOrderDetail(orderCode);
				 if (response.data) {
					 const detail = response.data
					 detail.goodsList = detail.goodsList.map(item => {
						 const tmp = item
						 tmp.num = item.cnt
						 return tmp
					 })
					 commit('save', {
						 detail: detail
					 })
				 } else {
					 Message.error({
						 message: '无此订单',
						 onClose: () => {
							 dispatch('closeDialog')
						 }
					 })
				 }
			})
		},
		async updateDetail({dispatch, commit, state}, payload) {
			const {orderCode} = state;
			await wait(dispatch, 'oms.order.detail', async function () {
				let response = await getOrderDetail(orderCode);
				if (response.data) {
					const detail = response.data
					detail.goodsList = detail.goodsList.map(item => {
						const tmp = item
						tmp.num = item.cnt
						return tmp
					})
					commit('save', {
						detail: detail
					})
				} else {
					Message.error({
						message: '无此订单'
					})
				}
			})
		},
		async getReturnReasonList({state, dispatch, commit}, payload) {
			await wait(dispatch, 'oms.problem.order.detail', async function () {
				await wait(dispatch, 'sms.order.return-reason-list', async function () {
					const response = await getReturnReasonList();
					if (response.data) {
						commit('save', {
							returnReasonList: response.data
						})
					}
				})
			})
		},
	},
	getters: {
		userData: state => {
			return [
				{
					label: 'Name',
					value: state.detail.name
				},
				{
					label: 'Address',
					value: state.detail.address
				},
				{
					label: 'PhoneNo',
					value: state.detail.phone
				},
				{
					label: 'Email',
					value: state.detail.email
				}
			]
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/modules/oms/problem-order/detail.js